module.exports = __webpack_public_path__ + "static/media/Excel.80b9f636.svg";